import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const kWatchFeatures: SubscriptionFeature[] = [
    SubscriptionFeature.KWatchNews,
    SubscriptionFeature.KWatchNewsFullNewsDetails,
    SubscriptionFeature.KWatchNewsNewsAttachments
];
